module.exports = __webpack_public_path__ + "static/media/ufg.cc6187d6.png";